{
    "Accessibility menu": "無障礙選單",
    "Close": "關閉",
    "Text and Reading": "文字與閱讀",
    "Navigation and Interaction": "導航與互動",
    "Text Align": "文字對齊",
    "Align Left": "靠左對齊",
    "Align Center": "置中對齊",
    "Align Right": "靠右對齊",
    "Adjust Font Size": "調整字型大小",
    "Highlight Title": "突顯標題",
    "Highlight Links": "突顯連結",
    "Readable Font": "易讀字型",
    "Color and Contrast": "顏色與對比度",
    "Dark Contrast": "深色對比",
    "Light Contrast": "淺色對比",
    "High Contrast": "高對比",
    "High Saturation": "高飽和度",
    "Low Saturation": "低飽和度",
    "Monochrome": "單色",
    "Tools": "工具",
    "Reading Guide": "閱讀指南",
    "Big Cursor": "大游標",
    "Increase Font Size": "放大字型",
    "Decrease Font Size": "縮小字型",
    "Letter Spacing": "字元間距",
    "Line Height": "行高",
    "Font Weight": "字型粗細",
    "Dyslexia Font": "閱讀障礙字型",
    "Language": "語言",
    "Accessibility widget": "開啟無障礙選單",
    "Accessibility Profiles": "無障礙設定檔",
    "Cognitive Disability": "認知障礙",
    "Seizure Safe": "癲癇安全",
    "Accessibility statement": "無障礙聲明",
    "ADHD": "注意力不足過動症",
    "Low Vision": "弱視",
    "Pause Animations": "暫停動畫",
    "Animation paused": "動畫已暫停",
    "Reset all settings": "重設所有設定",
    "Shortcut:": "快捷鍵：",
    "Epilepsy Safe Mode": "癲癇安全模式",
    "Mute sounds": "靜音",
    "Page read": "朗讀頁面",
    "Page read controls": "朗讀控制項",
    "Pause": "暫停",
    "Resume": "繼續",
    "Stop": "停止",
    "Settings": "設定",
    "Speed": "語速",
    "Voice": "語音",
    "Close accessibility menu": "關閉無障礙選單",
    "Back to accessibility menu": "返回無障礙選單",
    "Search languages": "搜尋語言",
    "Selected language": "已選擇的語言",
    "View accessibility statement (opens in new window)": "檢視無障礙聲明（在新視窗開啟）",
    "Visit CookieYes website (opens in new window)": "造訪 CookieYes 網站（在新視窗開啟）",
    "Reset all accessibility settings to default": "將所有無障礙設定重設為預設"
}
